import React, { useState, useEffect } from 'react';
import styles from './CoinbaseHome.module.scss';
import google_store_btn from '../../assets/imgs/btn_google_play_new.png';
import apple_store_btn from '../../assets/imgs/btn_apple_store_new.png';
// import qr_cdh from '../../assets/imgs/qr-with-cdh-img.svg';
import CDH_logo from '../../assets/imgs/cdh-profile-logo.png';
import HeroesItemsImg from '../../assets/imgs/CoinbaseHome/heroes_and_items.png';
import TOWERCoin from '../../assets/imgs/CoinbaseHome/TOWER_coin.png';
import MiddlePattern from '../../assets/imgs/CoinbaseHome/big_tower_pattern.png';
import HorizontalPattern from '../../assets/imgs/CoinbaseHome/long_pattern.png';
import { ReactComponent as TitleDivider } from '../../assets/imgs/CoinbaseHome/Divider_short.svg';
import MobileGameCharacters from '../../assets/imgs/CoinbaseHome/mobile_game_characters.png';
import BattleCardsImg from '../../assets/imgs/CoinbaseHome/battle_cards.png';
import OpenSeaLogo from '../../assets/icons/icon-opensea-simple.svg';
import OnePlanetLogo from '../../assets/icons/icon-oneplanet.png';
import BinanceLogo from '../../assets/imgs/home/icon-bsc-circle.png';
import HeroPointsLogo from '../../assets/imgs/CoinbaseHome/big_hero_pts.png';
import MobileGameItem from '../../assets/imgs/CoinbaseHome/mobile_game_item.png';
import DiscountSign from '../../assets/imgs/CoinbaseHome/discount_sign.png';
import { MediumNews } from '../../components';
import { getMediumArticles } from '../../services/mediumService';
import { EventsSection } from './EventsSection';
import { GameGallery } from '../../components/CoinbaseHomePageComponents';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import QRHero from '../../assets/imgs/QR codes/TOWER Website - Hero - main - 23 Dec 2022.svg';
import QRMiddle from '../../assets/imgs/QR codes/TOWER Wevsure - Middle - main - 23 Dec 2022.svg';
import QRCoinbaseHero from '../../assets/imgs/QR codes/TOWER Website - Hero - coinbase - 23 Dec 2022.svg';
import QRCoinbaseMiddle from '../../assets/imgs/QR codes/TOWER Website - Middle - coinbase - 23 Dec 2022.svg';

const CoinbaseCampaignName = process.env.REACT_APP_COINBASE_CAMPAIGN_NAME;

const cdhGpLink = "https://go.onelink.me/bUzl/9c836b67";
const cdhAppStoreLink = "https://go.onelink.me/VHLW/e01c1c3f";

const CoinbaseHome = () => {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        const fetchMediumArticles = async () => {
            const response = await getMediumArticles();
            if (response?.status == "ok") {
                setArticles(response.items.slice(0, 3));
            }
        }

        fetchMediumArticles();
    }, []);

    function checkSupportDOMParser() {
        if (!window.DOMParser) {
            return false;
        }
    
        const parser = new DOMParser();
        try {
            parser.parseFromString('x', 'text/html')
        } catch (err) {
            return false;
        }
        return true;
    }

    const purifyContent = (content) => {
        const regExp = /(\<script)\s*[^\>]*\>([^\<]*\<\/script>)?/gi;
        return content.replaceAll(regExp, '');
    }

    const stringToHTML = (content) => {
        const cleanContent = purifyContent(content)
        if (checkSupportDOMParser()) {
            const parser = new DOMParser();
            const html = parser.parseFromString(cleanContent, 'text/html')
            return html.body
        }

        const contentDiv = document.createElement('div')
        contentDiv.innerHTML = cleanContent
        return contentDiv
    }

    const processDescription = (description) => {
        var html = stringToHTML(description);
        var arr = Array.from(html.children);
        const filterComponents = arr.filter(component => component.tagName=="P" && component.tagName!="FIGURE" && component.tagName!="IMG")
        return filterComponents.reduce((wholeContent, thisContent)=> wholeContent += thisContent.innerText, '')
    }

    const processTimeFormat = (dateTime) => {
        const pubDate = new Date(dateTime)
        return (pubDate.toLocaleString('default', {month: 'short'}) + ' ' + pubDate.getDate())
    }

    return (
        <div className={styles.coinbase_home_container}>
            <section className={styles.coinbase_home}>
                <div className={styles.heroes_and_items}>
                    <img src={HeroesItemsImg} alt="heroes-and-items" />
                </div>

                <div className={styles.hero_intro}>
                    <div className={styles.game_title}>Crazy Defense Heroes</div>
                    <div className={styles.play_and_earn_sub_title}>
                        <div>Play Games, Own NFTs,</div>
                        <div>Earn TOWER</div>
                    </div>
                    <div className={styles.game_and_nft_links}>
                        <HashLink to={'/#game-play-and-earn'} className={styles.golden_btn}>
                            <div className={`${styles.btn_ornament} ${styles.left_ornament}`}></div>
                            <span>Game Details</span>
                            <div className={`${styles.btn_ornament} ${styles.right_ornament}`}></div>
                        </HashLink>
                        <HashLink to={'/#nfts-hold-claim-stake'} className={styles.view_nfts_btn}>View NFTs</HashLink>
                    </div>
                </div>

                <div className={styles.app_stats}>
                    <div className={styles.stat_container}>
                        <div className={styles.stat_title}>Top</div>
                        <div className={styles.stat_description}>Polygon Games in DappRadar</div>
                    </div>
                    <div className={styles.stats_separator}></div>
                    <div className={styles.stat_container}>
                        <div className={styles.stat_title}>20M +</div>
                        <div className={styles.stat_description}>Downloads</div>
                    </div>
                    <div className={styles.stats_separator}></div>
                    <div className={styles.stat_container}>
                        <div className={styles.stat_title}>100K +</div>
                        <div className={styles.stat_description}>Users</div>
                    </div>
                </div>

                <div className={styles.store_links}>
                    <div className={styles.download_now_text}>Download Now!</div>
                    <div className={styles.store_btns}>
                        <img src={CoinbaseCampaignName === window.location.host.split(".")[0] ? QRCoinbaseHero : QRHero} alt="app-store-qr" className={styles.app_qr} />
                        <div className={styles.app_store_btn_container}>
                            <a href={cdhAppStoreLink} target="_blank" rel="noopener noreferrer" className={styles.app_store_btn}>
                                <img src={apple_store_btn} alt="apple-app-store" />
                            </a>
                            <a href={cdhGpLink} target="_blank" rel="noopener noreferrer" className={styles.app_store_btn}>
                                <img src={google_store_btn} alt="google-app-store" />
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className={styles.events_section} id="events">
                <EventsSection />

                <div className={styles.horizontal_pattern}></div>
            </section>

            <section className={styles.what_is_tower_section} id="what-is-tower">
                <div className={styles.contents}>
                    <div className={styles.tower_coin_container}>
                        <img src={TOWERCoin} alt="tower-coin" />
                    </div>
                    <div className={styles.section_title}>What is TOWER?</div>
                    <div className={styles.horizontal_separator}></div>
                    <div className={styles.tower_details}>TOWER Token is an ERC-20 utility token of the TOWER Project initiated by Animoca Brands <a href="https://lightpaper.crazydefenseheroes.com/" target="_blank" rel="noopener noreferrer">Lightpaper</a></div>
                    <a href="https://medium.com/tower-token/the-crazy-kings-experiment-blending-f2p-gaming-and-tokens-in-crazy-defense-heroes-and-crazy-kings-7f7c0b231ca" target="_blank" rel="noopener noreferrer" className={styles.golden_btn}>
                        <div className={`${styles.btn_ornament} ${styles.left_ornament}`}></div>
                        <span>Project Details</span>
                        <div className={`${styles.btn_ornament} ${styles.right_ornament}`}></div>
                    </a>
                </div>

                <div className={styles.horizontal_pattern}>
                    <img src={HorizontalPattern} alt="horizontal-pattern" />
                </div>
                <div className={styles.middle_pattern}>
                    <img src={MiddlePattern} alt="middle-pattern" />
                </div>
            </section>

            <section className={styles.game_play_earn_section} id="game-play-and-earn">
                <div className={styles.page_separator}></div>
                <div className={styles.game_play_earn_title}>
                    <div>Game · Play And Earn</div>
                    <div className={styles.title_divider}>
                        <TitleDivider />
                    </div>
                </div>

                <div className={styles.game_play_earn_contents}>
                    <div className={styles.game_details}>
                        <div className={styles.game_details_and_links}>
                            <div className={styles.game_details_and_links_title}>Crazy Defense Heroes</div>

                            <div className={styles.game_play_earn_store_links}>
                                <div>
                                    <img src={CDH_logo} alt="cdh-logo" className={styles.cdh_logo} />
                                    <img src={CoinbaseCampaignName === window.location.host.split(".")[0] ? QRCoinbaseMiddle : QRMiddle} alt="app-store-qr" className={styles.app_qr} />
                                </div>
                                <div className={styles.app_store_btn_container}>
                                    <a href={cdhAppStoreLink} target="_blank" rel="noopener noreferrer" className={styles.app_store_btn}>
                                        <img src={apple_store_btn} alt="apple-app-store" />
                                    </a>
                                    <a href={cdhGpLink} target="_blank" rel="noopener noreferrer" className={styles.app_store_btn}>
                                        <img src={google_store_btn} alt="google-app-store" />
                                    </a>
                                </div>
                            </div>

                            <div className={styles.game_details_and_links_details}>
                                Download Crazy Defense Heroes mobile game on App Store or Google Play to start your Web3 Play-and-Earn Journey!
                            </div>
                            <a href="https://crazydefenseheroes.fandom.com/wiki/Category:Complete_Guideline" target="_blank" rel="noopener noreferrer" className={styles.how_to_play_link}>
                                How to Play?
                            </a>
                        </div>

                        <div className={styles.mobile_game_character}>
                            <img src={MobileGameCharacters} alt="mobile-game-characters" />
                        </div>
                    </div>

                    <div className={styles.game_gallery_container}>
                        <GameGallery />
                    </div>
                </div>
            </section>

            <section className={styles.ntfs_hold_claim_stake_section} id="nfts-hold-claim-stake">
                <div className={styles.page_separator}></div>
                <div className={styles.game_play_earn_title}>
                    <div>NFTs · Hold to Claim & Stake</div>
                    <div className={styles.title_divider}>
                        <TitleDivider />
                    </div>
                </div>

                <div className={styles.ntfs_hold_claim_stake_contents}>
                    <div className={styles.cards_and_tickets_details}>
                        <div className={styles.cards_and_tickets_details_and_links}>
                            <div className={styles.title}>
                                <div className={`${styles.decoration} ${styles.left}`}></div>
                                <div>Battle Cards / Tickets</div>
                                <div className={`${styles.decoration} ${styles.right}`}></div>
                            </div>
                            <div className={styles.title_two}>Hold TOWER NFTs to claim Rewards</div>
                            <div className={styles.details}>Hold at least 1 Battle Card / Ticket NFT to claim TOWER Token & NFT rewards from</div>
                            <a href="https://crazydefenseheroes.fandom.com/wiki/Category:Complete_Guideline" target="_blank" rel="noopener noreferrer" className={styles.how_it_works_link}>
                                How it works?
                            </a>

                            <div className={styles.market_place_container}>
                                <div className={styles.market_place}>
                                    <div className={styles.title}>Buy Battle Cards</div>
                                    <div className={styles.links_container}>
                                        <div className={styles.links_and_network}>
                                            <div className={styles.links}>
                                                <a href={'https://opensea.io/collection/tower-battle-cards'} target="_blank" rel="noopener noreferrer" className={styles.market_place_link}>
                                                    <img src={OpenSeaLogo} alt="opensea" />
                                                </a>
                                                <a href={'https://www.oneplanetnft.io/collections/items/0xcf501ead3ebfa60f40725fca1d82fc05bff63bf2?utm_source=oneplanet&utm_medium=display&utm_campaign=main+banner&sort=price_low_to_high'} target="_blank" rel="noopener noreferrer" className={styles.market_place_link}>
                                                    <img src={OnePlanetLogo} alt="oneplanet" />
                                                </a>
                                            </div>
                                            <div className={styles.notice}>*On Polygon Chain</div>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.market_place}>
                                    <div className={styles.title}>Buy Tickets</div>
                                    <div className={styles.links_container}>
                                        <div className={styles.links_and_network}>
                                            <div className={styles.links}>
                                                <a href={'https://opensea.io/collection/tower-treasury'} target="_blank" rel="noopener noreferrer" className={styles.market_place_link}>
                                                    <img src={OpenSeaLogo} alt="opensea" />
                                                </a>
                                                <a href={'https://www.oneplanetnft.io/collections/items/0x2b88ce7b01e6bdbb18f9703e01286608cf77e805?sort=price_low_to_high'} target="_blank" rel="noopener noreferrer" className={styles.market_place_link}>
                                                    <img src={OnePlanetLogo} alt="oneplanet" />
                                                </a>
                                            </div>
                                            <div className={styles.notice}>*On Polygon Chain</div>
                                        </div>
                                        <div className={styles.links_separator}></div>
                                        <div className={styles.links_and_network}>
                                            <div className={styles.links}>
                                                <a href={'https://www.binance.com/en/nft/profile/animoca-brands-ad3bcf389e3eb2213724659b99b94cd0?category=created'} target="_blank" rel="noopener noreferrer" className={styles.market_place_link}>
                                                    <img src={BinanceLogo} alt="binance" />
                                                </a>
                                            </div>
                                            <div className={styles.notice}>*On BNB Chain</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.cards_display}>
                            <img src={BattleCardsImg} alt="mobile-game-characters" />
                        </div>
                    </div>
                </div>
            </section>

            <section className={styles.tower_league_hero_points_section} id="tower-league-hero-points">
                <div className={styles.page_separator}></div>
                <div className={styles.tower_league_hero_points_title}>
                    <div>TOWER League · Hero Points</div>
                    <div className={styles.title_divider}>
                        <TitleDivider />
                    </div>
                </div>

                <div className={styles.tower_league_hero_points_contents}>
                    <div className={styles.event_details}>
                        <div className={styles.details}>
                            <div className={styles.title}>Earned from exclusive CDH event!</div>
                            <div className={styles.coming_soon}>Coming Soon...</div>
                            <div className={styles.details}>Earn TOWER Hero Points to Redeem exclusive items, including NFTs, physical merch, and personal experiences!</div>
                            <a href={'https://medium.com/tower-token/introducing-the-2022-crazy-defense-heroes-halloween-invasion-bored-ape-edition-aba2ffa6088c'} target="_blank" rel="noopener noreferrer" className={styles.more_details_link}>
                                {'More Details >'}
                            </a>
                        </div>
                        <div className={styles.hero_points_logo}>
                            <img src={HeroPointsLogo} alt='hero-points' />
                        </div>
                    </div>
                </div>
            </section>

            <section className={styles.web_store_section} id="web-store">
                <div className={styles.page_separator}></div>
                <div className={styles.web_store_section_title}>
                    <div>Web Store</div>
                    <div className={styles.title_divider}>
                        <TitleDivider />
                    </div>
                </div>

                <div className={styles.web_store_section_contents}>
                    <div className={styles.item_detail_container}>
                        <div className={styles.item}>
                            <div className={styles.item_image}>
                                <img src={MobileGameItem} alt="mobile-game-item" />
                            </div>
                            <div className={styles.item_title}>Mobile Game Items & NFTs</div>
                            <div className={styles.item_description}>Purchase CDH mobile Game Items and NFTs with TOWER Tokens</div>
                        </div>

                        <div className={styles.item}>
                            <div className={styles.item_image}>
                                <img src={DiscountSign} alt="discount" />
                            </div>
                            <div className={styles.item_title}>Exclusive Discount</div>
                            <div className={styles.item_description}>Great offers only available on the Web Store</div>
                        </div>
                    </div>
                    <Link to={'/store/starter-packs'} className={styles.golden_btn}>
                        <div className={`${styles.btn_ornament} ${styles.left_ornament}`}></div>
                        <span>View Web Store</span>
                        <div className={`${styles.btn_ornament} ${styles.right_ornament}`}></div>
                    </Link>
                </div>

                <div className={styles.horizontal_pattern}></div>
            </section>

            <section className={styles.news_section} id="news">
                <div className={styles.page_separator}></div>
                <div className={styles.news_section_title}>
                    <div>News</div>
                    <div className={styles.title_divider}>
                        <TitleDivider />
                    </div>
                </div>

                <div className={styles.news_section_contents}>
                    <div className={styles.news_scroll}>
                        {articles.length > 0
                            ? articles.map (function(object, i) {
                                    return <MediumNews key={i} content={{
                                        image: object.thumbnail,
                                        title: object.title,
                                        description: processDescription(object.description),
                                        time: processTimeFormat(object.pubDate),
                                        redirectUrl: object.guid
                                }}/>
                            })
                            : <></>
                        }
                    </div>
                </div>
                <div className={styles.page_separator_bottom}></div>
            </section>
        </div>
    )
}

export { CoinbaseHome };
